const getParsedLocalStorageData = (KEY: string) => {
  if (typeof localStorage !== "undefined") {
    let data = localStorage.getItem(KEY);
    if (data) {
      // Parse it to a javaScript object
      try {
        data = JSON.parse(data);
      } catch (err) {
        console.error(err);
      }
      return data;
    }
  }
  return {};
};

export default getParsedLocalStorageData;
